export enum ApiDataStatus {
    Loading,
    GenericError,
}
